import { hexToRgbaString } from './helpers-fns.ts';

export const simpleColors = {
  completelyBlack: '#000',
  shark: '#191C20',
  mirage: '#1A222C',
  codGray: '#1E1E1E',
  shark2: '#222627',
  outerSpace: '#292D2E',
  ebonyClay: '#24303F',
  pickledBluewood: '#2A3D54',
  capeCod: '#323838',
  capeCod2: '#495555',
  abbey: '#545758',
  blueRibbon: '#2151F5',
  cornflowerBlue: '#5765F2',
  redViolet: '#C7169B',
  luxorGold: '#A88F33',
  hotToddy: '#B8860B',
  earlsGreen: '#C4A735',
  mountainMeadow: '#16C782',
  springGreen: '#25EE8B',
  sunsetOrange: '#FF544A',
  starShip: '#D5ED44',
  silverChalice: '#AEAEAE',
  nobel: '#B4B4B4',
  gallery: '#EFEFEF',
  deepPink: '#FF008F',
  completelyWhite: '#FFF',
} as const;

export type SimpleColorName = keyof typeof simpleColors;
export type SimpleColorValue = (typeof simpleColors)[SimpleColorName];

export const gradientColors = {
  /*gradientPrimaryColor: `linear-gradient(94.1deg, ${simpleColors.mandy} 0%, ${simpleColors.punch} 99.58%);`,
  gradientPrimaryInvertedColor: `linear-gradient(94.1deg, ${simpleColors.punch} 0%, ${simpleColors.mandy} 99.58%);`,
  gradientSecondaryColor: `linear-gradient(94.1deg, ${simpleColors.silverTree} 0%, ${simpleColors.oceanGreen} 99.58%), linear-gradient(94.1deg, ${simpleColors.horizon} 0%, ${simpleColors.eastBay} 99.58%);`,
  gradientSecondaryInvertedColor: `linear-gradient(94.1deg, ${simpleColors.oceanGreen} 0%, ${simpleColors.silverTree} 99.58%), linear-gradient(94.1deg, ${simpleColors.eastBay} 0%, ${simpleColors.horizon} 99.58%)`,
  gradientModalBackground: `linear-gradient(134.78deg, ${simpleColors.shark} -8.57%, ${simpleColors.gondola} 101.36%, ${simpleColors.gondola2} 104.3%)`,
  gradientButtonBackground: `linear-gradient(350.98deg, ${simpleColors.friarGray} -87.56%, ${simpleColors.friarGray2} 277.62%)`,*/
} as const;

export type GradientColorName = keyof typeof gradientColors;
export type GradientColorValue = (typeof gradientColors)[GradientColorName];

export const rgbaColors = {
  rgbaBgColor: 'rgba(17, 24, 39, 0.5)',
  // rgba(41, 45, 46, 0.8) #292D2E
  rgbaBlackBgColor: hexToRgbaString(simpleColors.mirage, 0.8),
  rgbaBlackBg2Color: hexToRgbaString(simpleColors.outerSpace, 0.2),
  rgbaBlockBgColor: hexToRgbaString(simpleColors.outerSpace, 0.8),
  rgbaWhite50Color: hexToRgbaString(simpleColors.completelyWhite, 0.5),
} as const;

export type RgbaColorName = keyof typeof rgbaColors;
export type RgbaColorValue = (typeof rgbaColors)[RgbaColorName];

export const greenThemeTypedColors = {
  accentPrimary: simpleColors.silverChalice,
  accentSecondary: simpleColors.springGreen,
  bgScreen: simpleColors.shark2,
  bgCards: simpleColors.outerSpace,
  bgCardsActive: simpleColors.capeCod,
  textDark: simpleColors.capeCod2,
  active: simpleColors.starShip,
  ratesDown: simpleColors.sunsetOrange,
  horseGroupGold: simpleColors.luxorGold,
  horseGroupSilver: simpleColors.nobel,
  error: simpleColors.redViolet,
} as const;

export const pinkThemeTypedColors = {
  accentPrimary: simpleColors.silverChalice,
  accentSecondary: simpleColors.deepPink,
  bgScreen: simpleColors.shark2,
  bgCards: simpleColors.outerSpace,
  bgCardsActive: simpleColors.capeCod,
  textDark: simpleColors.capeCod2,
  active: simpleColors.starShip,
  ratesDown: simpleColors.sunsetOrange,
  horseGroupGold: simpleColors.luxorGold,
  horseGroupSilver: simpleColors.nobel,
  error: simpleColors.redViolet,
} as const;

export const blueThemeTypedColors: {
  [key in TypedColorName]: SimpleColorValue;
} = {
  accentPrimary: simpleColors.completelyWhite,
  accentSecondary: simpleColors.blueRibbon,
  bgScreen: simpleColors.shark,
  bgCards: simpleColors.mirage,
  bgCardsActive: simpleColors.ebonyClay,
  textDark: simpleColors.pickledBluewood,
  active: simpleColors.mountainMeadow,
  ratesDown: simpleColors.redViolet,
  horseGroupGold: simpleColors.luxorGold,
  horseGroupSilver: simpleColors.nobel,
  error: simpleColors.redViolet,
};

export type TypedColorName = keyof typeof greenThemeTypedColors;
export type TypedColorValue = (typeof greenThemeTypedColors)[TypedColorName];

export type ColorName = SimpleColorName | GradientColorName | RgbaColorName | TypedColorName;
export type ColorValue = SimpleColorValue | GradientColorValue | RgbaColorValue | TypedColorValue;
